<template>
    <svg width="20" height="27" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 6">
    <path id="Combined Shape" fill-rule="evenodd" clip-rule="evenodd" d="M19.5183 8.02187C21.7315 20.0733 9.91927 26.5503 9.91927 26.5503V26.5402C9.57059 26.3458 -1.82948 19.8893 0.349942 8.02187L9.91927 0.00909895V0L9.92471 0.00454502L9.92743 0.00226896V0.00681661L19.5183 8.02187Z" fill="url(#paint0_linear_1356_7541)"/>
    <g id="Group 13">
    <path id="Combined Shape_2" fill-rule="evenodd" clip-rule="evenodd" d="M9.94037 8.91211C8.58652 8.91211 7.52008 10.1586 7.52008 11.6624C7.52008 11.6796 7.52085 11.6967 7.52236 11.7135C6.80937 12.0192 6.30994 12.7275 6.30994 13.5524V16.4073C6.30994 17.5119 7.20537 18.4073 8.30994 18.4073H11.5708C12.6754 18.4073 13.5708 17.5119 13.5708 16.4073V13.5524C13.5708 12.7275 13.0714 12.0192 12.3584 11.7135C12.3599 11.6967 12.3607 11.6796 12.3607 11.6624C12.3607 10.1586 11.2942 8.91211 9.94037 8.91211ZM9.94037 10.0122C10.6368 10.0122 11.2353 10.6793 11.282 11.5524H8.5987C8.6454 10.6793 9.2439 10.0122 9.94037 10.0122ZM10.9305 15.1829C10.9305 15.614 10.655 15.9807 10.2704 16.1166V17.4931H9.61033V16.1166C9.22577 15.9807 8.95025 15.614 8.95025 15.1829C8.95025 14.636 9.39354 14.1927 9.94037 14.1927C10.4872 14.1927 10.9305 14.636 10.9305 15.1829Z" fill="white"/>
    </g>
    </g>
    <defs>
    <linearGradient id="paint0_linear_1356_7541" x1="-1.96319" y1="26.5503" x2="25.3984" y2="30.5226" gradientUnits="userSpaceOnUse">
    <stop stop-color="#3F5CBD"/>
    <stop offset="1" stop-color="#1BC8CE"/>
    </linearGradient>
    </defs>
    </svg>
</template>

<script>
export default {
    name: 'safe-certify-icon'
}
</script>
